import { render, staticRenderFns } from "./Sift.vue?vue&type=template&id=5876cb90&scoped=true&"
import script from "./Sift.vue?vue&type=script&lang=js&"
export * from "./Sift.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5876cb90",
  null
  
)

export default component.exports